/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback, useEffect, useState } from 'react'
import 'katex/dist/katex.min.css'
import { InlineMath } from 'react-katex'
import {
  IAlternative,
  IQuestion,
} from '../../pages/SearchQuestions/components/SearchQuestionsContent/types'
import {
  Container,
  Statement,
  Option,
  Options,
  Answer,
  CommentsButton,
  CommentsContainer,
  CommentsHeader,
  CommentsText,
  Buttons,
  Result,
  Header,
  DetailsDropdown,
  CanceledQUestion,
  AssociatedTextContainer,
  AssociatedTextHeader,
  AssociatedTextContent,
} from './styles'
import { IoIosArrowDown, IoIosArrowUp, IoMdArrowDropright } from 'react-icons/io'
import { BsEye, BsEyeSlash, BsChatRightQuote, BsX } from 'react-icons/bs'
import { useUncontrolled } from '../../hooks/use-uncontrolled'
import { learningApi } from '../../services/api'
import { useSelector } from 'react-redux'
import { RootState } from '../../store/modules/rootReducer'
import { toast } from 'react-toastify'
import { IBookQuestion } from '../../pages/QuestionBook/components/QuestionBookComponent/types'
import ReactDOM from 'react-dom'
import { setState } from '../../types/setState'
import TooltipWrapper from 'pages/MyQuestionBooks/components/TooltipWrapper'

interface IProps {
  position: number
  data: IQuestion | IBookQuestion
  fontSize: number

  hideTheme?: boolean
  onHideTheme?(val: boolean): void

  hideDetails?: boolean
  onHideDetails?(val: boolean): void

  onAnswer?(): void
  setTracking: setState

  id: string

  dataKey?: string
  unanswered(): void
}

enum EAlternative {
  'A' = 0,
  'B' = 1,
  'C' = 2,
  'D' = 3,
  'E' = 4,
}

const Question = (props: IProps) => {
  const token = localStorage.getItem('token')
  const { profile } = useSelector((state: RootState) => state.student)
  const [key, setKey] = useState<string>()
  const [sumary, setSumary] = useState<boolean>(false)
  const [showComments, setShowComments] = useState<boolean>(false)
  const [showAssociatedText, setShowAssociatedText] = useState<boolean>(false)
  const [selected, setSelected] = useState<IAlternative['letter'] | null>(() => {
    if ('answer' in props.data && props.data.answer.answerDate) {
      return EAlternative[Number(props.data.answer.alternative)]
    }

    return null
  })

  const [correctAnswer, setCorrectAnswer] = useState<IAlternative['letter'] | null>(() => {
    if ('answer' in props.data && props.data.answer.answerDate) {
      return EAlternative[Number(props.data.rightAlternative)]
    }

    return null
  })
  const [hideDetails, setHideDetails] = useUncontrolled({
    value: props.hideDetails,
    defaultValue: false,
    finalValue: false,
    onChange: props.onHideDetails,
  })
  const [hideTheme, setHideTheme] = useUncontrolled({
    value: props.hideTheme,
    defaultValue: false,
    finalValue: false,
    onChange: props.onHideTheme,
  })

  const number = props.data.questionNumber || props.position

  const result = (() => {
    if (!selected || !correctAnswer) return null

    if (selected === correctAnswer) {
      return 'right'
    } else {
      return 'wrong'
    }
  })()

  const hierarchies = {
    level0: props.data.hierarchies.filter((hierarchy) => hierarchy.level === 0)[0],
    level1: props.data.hierarchies.filter((hierarchy) => hierarchy.level === 1)[0],
  }

  const answerQuestion = async () => {
    const rightAlternative = EAlternative[Number(props.data.rightAlternative)]
    const hit = rightAlternative === selected

    setCorrectAnswer(rightAlternative)

    await learningApi
      .post(
        '/question/monitoring',
        {
          answer: {
            hit,
            alternative: String(EAlternative[selected || key]),
          },
          item: props.data._id,
          hierarchies: props.data.hierarchies,
          student: {
            _id: profile._id,
            name: profile.name,
            email: profile.email,
          },
          questionBook: props.data.questionBook ?? null,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .catch((err) => {
        if (err.response.status === 401) return
        console.error(err)
        toast.error('Houve um erro ao registrar o seu progresso!')
      })

    props.setTracking({
      event: 'QuestionAnswer',
      properties: {
        ...props.data,
        hit,
        selected,
        source: props.data.questionBook ? 'Caderno' : 'Listagem',
      },
    })

    if (props.onAnswer) props.onAnswer()
  }

  const comment = props.data.comment
  const professor = props.data.professor

  useEffect(() => {
    verificarComponente('sumary')
  }, [])
  function verificarComponente(idComponente) {
    const elemento = document.getElementById(idComponente)
    if (elemento) {
      setSumary(true)
    } else {
      setSumary(false)
    }
  }
  useEffect(() => {
    const handleKeyPress = (event: KeyboardEvent) => {
      if (sumary === true && window.innerWidth > 800) {
        setKey(event.key)
        switch (event.key) {
          case 'A':
          case 'a':
          case '1':
            {
              const alternativeA = document.querySelector('#alternative-A') as HTMLDivElement

              alternativeA.focus()
              alternativeA.click()
            }

            break
          case 'B':
          case 'b':
          case '2':
            {
              const alternativeB = document.querySelector('#alternative-B') as HTMLDivElement

              alternativeB.focus()
              alternativeB.click()
            }
            break
          case 'C':
          case 'c':
          case '3':
            if (props.data.type === 'CERTO_ERRADO' && event.key !== '3') {
              {
                const alternativeA = document.querySelector('#alternative-A') as HTMLDivElement

                alternativeA.focus()
                alternativeA.click()
              }
            } else {
              {
                const alternativeB = document.querySelector('#alternative-C') as HTMLDivElement

                alternativeB.focus()
                alternativeB.click()
              }
            }
            break
          case 'D':
          case 'd':
          case '4':
            {
              const alternativeB = document.querySelector('#alternative-D') as HTMLDivElement

              alternativeB.focus()
              alternativeB.click()
            }
            break
          case 'E':
          case 'e':
          case '5':
            if (props.data.type === 'CERTO_ERRADO' && event.key !== '5') {
              {
                const alternativeA = document.querySelector('#alternative-B') as HTMLDivElement

                alternativeA.focus()
                alternativeA.click()
              }
            } else {
              {
                const alternativeB = document.querySelector('#alternative-E') as HTMLDivElement

                alternativeB.focus()
                alternativeB.click()
              }
            }

            break
          case 'N':
          case 'n':
            props.unanswered()

            break
          case 'Enter': {
            const target = event.target as HTMLDivElement

            if (target.id.includes('alternative-') && target.dataset.selected === 'true') {
              const submitButton = document.querySelector('#submitButton') as HTMLDivElement

              submitButton.click()
            }
          }
        }
      }
    }

    window.addEventListener('keydown', handleKeyPress)
    return () => {
      window.removeEventListener('keydown', handleKeyPress)
    }
  }, [answerQuestion])

  const renderOption = (option: IAlternative) => {
    const isSelected = selected === option.letter
    const isWrong = isSelected && correctAnswer && correctAnswer !== option.letter
    const isCorrect = correctAnswer === option.letter

    const modifiedAnswer = option.answer
      .replace('<video', '<video class="video-component"')
      .replaceAll(/style="color:.*?"/g, '')

    return (
      <Option
        id={`alternative-${option.letter}`}
        fontSize={props.fontSize}
        key={option.letter}
        data-selected={isSelected}
        data-wrong={isWrong}
        data-correct={isCorrect}
        disabled={Boolean(correctAnswer) || props.data.canceled === true}
        data-Canceled={props.data.canceled === true ? 'true' : 'false'}
        onClick={() =>
          setSelected((prev) => {
            if (prev === option.letter) return null

            return option.letter
          })
        }
      >
        <div className="letter">{option.letter}</div>
        <span
          className={`text questionOption-${props.data.code}`}
          dangerouslySetInnerHTML={{
            __html: modifiedAnswer || '',
          }}
        />
      </Option>
    )
  }

  const renderSpecialCharacters = useCallback(() => {
    const optionsTags = document.getElementsByClassName(`questionOption-${props.data.code}`)
    const statementTag = document.getElementById(`question-option-${props.data.code}`)
    const associatedTextTag = document.getElementById(`associated-text-${props.data.code}`)

    const elements = [...Array.from(optionsTags), statementTag, associatedTextTag].filter(Boolean)

    if (!elements.length) return

    elements.forEach((el) => {
      const htmlContent = el.innerHTML
      el.innerHTML = htmlContent.replace(/\\[n|r|t]/g, '<br>')
    })
  }, [props.data.code])

  const renderMathForm = useCallback(() => {
    const tags = document.getElementsByTagName('math-component')
    if (tags && tags.length) {
      for (let i = 0; i < tags.length; i++) {
        const newEl = tags[i].insertAdjacentElement('afterend', document.createElement('div'))
        newEl.id = `math${i}`
        newEl.setAttribute('style', tags[i].getAttribute('style') || '')

        const mathElem = tags[i] as HTMLDivElement

        mathElem.style.display = 'none'

        ReactDOM.render(<InlineMath math={tags[i].innerHTML} />, newEl, () => {
          if (i === tags.length - 1) {
            renderSpecialCharacters()
          }
        })
      }
    }
  }, [renderSpecialCharacters])

  const handleCopyQuestionCode = (code: string) => {
    navigator.clipboard.writeText(code)
    toast.success('Código copiado com sucesso')
  }

  useEffect(() => {
    if (props.data) renderMathForm()
  }, [props.data, renderMathForm])

  // useEffect(() => {
  //   if (!selected || Boolean(correctAnswer)) {
  //     setButtonDisabled(true)
  //   } else if (keyValid === true) {
  //     setButtonDisabled(false)
  //   }
  // }, [correctAnswer, keyValid, selected, props.data])

  const modifiedHTML = props.data?.title
    .replace('<video', '<video class="video-component"')
    .replaceAll(/style="color:.*?"/g, '')

  const contextualReference = props.data.references
    ?.filter((r) => r?.visible !== false)
    ?.find((ref) => ['CONTEXTUAL', 'TABELA'].includes(ref.category))
  const modifiedAssociatedTextHTML = contextualReference?.title
    ?.replace('<video', '<video class="video-component"')
    .replaceAll(/style="color:.*?"/g, '')

  const imageBasedReference = props.data.references
    ?.filter((r) => r?.visible !== false)
    ?.find((ref) => ref.category === 'IMAGE-BASED')

  return (
    <Container id={props.id}>
      <Header>
        <div className="number">{number < 10 ? `0${number}` : number}</div>
        <TooltipWrapper text={props.data.code} className="tooltip-wrapper">
          <button className="code" onClick={() => handleCopyQuestionCode(props.data.code)}>
            Copiar <br /> código da <br /> questão
          </button>
        </TooltipWrapper>
        <div className="hierarchy">
          <p className="subject">{hierarchies.level0?.name}</p>
          {hideTheme ? (
            <p className="dots">...</p>
          ) : (
            <>
              <IoMdArrowDropright className="arrow" size={20} />
              <p className="theme">{hierarchies.level1?.name}</p>
            </>
          )}
        </div>
        <button className="eye-button" onClick={() => setHideTheme(!hideTheme)}>
          {hideTheme ? <BsEye className="icon" /> : <BsEyeSlash className="icon" />}
        </button>
        <button className="arrow-button" onClick={() => setHideTheme(!hideTheme)}>
          {hideTheme ? <IoIosArrowDown className="icon" /> : <IoIosArrowUp className="icon" />}
        </button>
      </Header>
      <DetailsDropdown>
        <div className="dropdown" data-hidden={hideDetails}>
          <div className="texts" data-flex={props.data.exam?.roles ? true : false}>
            <div className="group-1" data-flex={props.data.exam?.roles ? true : false}>
              <p className="year">
                <b> Ano:</b> {props.data.exam.year}
              </p>
              <p className="banking">
                <b> Banca:</b> {props.data.exam.evaluatingInstitution.abbreviation}
              </p>
            </div>
            <p className="group-2" data-flex={props.data.exam?.roles ? true : false}>
              {props.data.exam?.roles ? (
                <span className="roles">
                  <b> Cargo:</b> {props.data.exam.roles[0]}
                </span>
              ) : null}
              <span className="inline">
                <b> Órgão:</b> {props.data.exam.publicTender.name}
              </span>
            </p>

            {/* <p className="shrink-0">
              
            </p> */}
            {/* <p>
              <b>Prova:</b> <span className="inline"> - </span>
            </p> */}
          </div>

          <button className="close" onClick={() => setHideDetails(true)}>
            Ocultar detalhes da questão
          </button>
        </div>
        <button className="open" hidden={!hideDetails} onClick={() => setHideDetails(false)}>
          Detalhes da questão
        </button>
      </DetailsDropdown>

      {props.data.canceled === true ? (
        <CanceledQUestion>
          <h4 className="canceled">ANULADA</h4>
        </CanceledQUestion>
      ) : null}

      {contextualReference && (
        <AssociatedTextContainer>
          <AssociatedTextHeader onClick={() => setShowAssociatedText(!showAssociatedText)}>
            <span>Texto associado</span>
            {showAssociatedText ? <IoIosArrowUp /> : <IoIosArrowDown />}
          </AssociatedTextHeader>
          {showAssociatedText && (
            <AssociatedTextContent
              id={`associated-text-${props.data.code}`}
              fontSize={props.fontSize}
              dangerouslySetInnerHTML={{
                __html: modifiedAssociatedTextHTML || '',
              }}
            />
          )}
        </AssociatedTextContainer>
      )}

      {imageBasedReference && (
        <AssociatedTextContainer>
          <AssociatedTextHeader onClick={() => setShowAssociatedText(!showAssociatedText)}>
            <span>Imagem associada</span>
            {showAssociatedText ? <IoIosArrowUp /> : <IoIosArrowDown />}
          </AssociatedTextHeader>
          {showAssociatedText && (
            <img
              src={imageBasedReference.title}
              alt={imageBasedReference.text}
              className="max-w-none w-auto h-auto"
            />
          )}
        </AssociatedTextContainer>
      )}

      <Statement
        id={`question-option-${props.data.code}`}
        fontSize={props.fontSize}
        dangerouslySetInnerHTML={{
          __html: modifiedHTML || '',
        }}
      />
      <Options className="alternatives">{props.data.alternatives.map(renderOption)}</Options>
      <Buttons>
        <div className="group-1">
          <Answer
            id="submitButton"
            disabled={!selected || Boolean(correctAnswer)}
            onClick={() => answerQuestion()}
          >
            Responder
          </Answer>
          {result && (
            <Result data-result={result}>
              <p className="label">
                {result === 'right' && 'Resposta correta!'}
                {result === 'wrong' && 'Resposta errada!'}
              </p>
              {result === 'wrong' && (
                <div className="correct">
                  Alternativa correta:{' '}
                  <div className="letter">{EAlternative[Number(props.data.rightAlternative)]}</div>
                </div>
              )}
            </Result>
          )}
        </div>
        <div className="group-2">
          <CommentsButton
            disabled={!comment?.description}
            onClick={() => setShowComments(!showComments)}
          >
            <BsChatRightQuote className="icon" /> Comentário do professor (
            {comment?.description ? 1 : 0})
          </CommentsButton>
        </div>
      </Buttons>

      <CommentsContainer open={showComments} className={showComments ? 'open' : ''}>
        <CommentsHeader>
          <div>
            <h3>Comentários - {professor?.name || 'Equipe Direção Concursos'}</h3>
          </div>
          <BsX onClick={() => setShowComments(!showComments)} />
        </CommentsHeader>
        <CommentsText
          fontSize={props.fontSize}
          dangerouslySetInnerHTML={{
            __html: comment?.description?.replaceAll(/style="color:.*?"/g, '') || '',
          }}
        />
      </CommentsContainer>
      {/* {comment ? comment.description : 'Sem comentário'} */}
    </Container>
  )
}

export default Question
